module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am93-dd7b974717827103a8f720152f504e31.jpg";